import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Validator that checks if the date is not greater than the maximum date.
 * @param maxDate The maximum date allowed.
 * @returns A validator function that checks the date.
 */
export function maxDateValidator(maxDate?: Date): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const date = new Date(control.value);
		const value = date.getTime();

		// set maxDate to end of day
		if (maxDate) maxDate.setHours(23, 59, 59, 999);

		if (!value || !maxDate || value <= maxDate.getTime()) {
			return null;
		}

		return { maxDateExceeded: true };
	};
}

export function minDateValidator(minDate?: Date): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {
		const date = new Date(control.value);
		const value = date.getTime();

		if (!value || !minDate || value >= minDate.getTime()) {
			return null;
		}

		return { minDateExceeded: true };
	};
}
